import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-999",
  "use": "icon-999-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" fill=\"currentColor\" class=\"qi-999\" viewBox=\"0 0 16 16\" id=\"icon-999\">\n  <path d=\"M4.669 9 2.08 5.171H.991v6.05h1.202V7.41l2.584 3.811h1.095v-6.05H4.669V9zm8.219-3.829H11.66l-2.125 6.05h1.281l.396-1.247h2.107l.37 1.247h1.308zm-1.352 3.793.746-2.37.711 2.37zM9.29 4.98a.5.5 0 0 0-.631.317L6.88 10.661a.5.5 0 1 0 .949.315l1.778-5.364a.5.5 0 0 0-.317-.632z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol